import React, { useEffect } from 'react';

import styled from 'styled-components';

import { RED } from '../../config/colors';

import { RootPortal } from '../RootPortal';

const Overlay = styled.div`
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    z-index: ${props => props.top ? '18000' : '9000'};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: all 0.3s;
    visibility: ${props => props.visible ? 'visible' : 'hidden'};
    opacity: ${props => props.visible ? '1' : '0'};

`;

const StyledInformationDialog = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: 5px;
    max-height: calc(100vh - 30px);
    max-width: ${props => props.width ? props.width : '500px'};
    width: 100%;
    @media screen and (max-width: 390px) {
        max-height: calc(100vh - 30px);
        max-height: calc(100svh - 30px);
    }

    @media (max-width: ${props => props.width ? props.width : '515px'}) {
        width: 90vw;
    }
`;

const StyledInformationDialogContentWrapper = styled.div`
    overflow: auto;
    max-height: calc(100vh - 30px);
    padding: 30px;
    line-height: 1.25em;

    @media screen and (max-width: 390px) {
        max-height: calc(100vh - 30px);
        max-height: calc(100svh - 60px);
    }

    @media screen and (max-width: 1920px) and (min-width: 1024px) {
        padding: 26px;
        font-size: 14px;
        line-height: 20px;
    }
`;

export const CloseButton = styled.button`
    @include square(32 px);
    display: block;
    color: white;
    font-size: 32px;
    font-family: arial, sans-serif;
    line-height: 20px;
    cursor: pointer;
    z-index: 9010;
    background-color: rgba(0, 0, 0, 1);
    border: 0;
    padding: 15px;
    transition: background-color, .3s;

    &:hover {
        background-color: ${RED};
        color: #fafafa;
    }
`;

const InformationDialogCloseButton = styled(CloseButton)`
    position: absolute;
    top: -1px;
    right: -1px;
    font-size: 44px;
    padding: 10px;
    border-radius: 0 7px 0 0;

    @media screen and (max-width: 1920px) and (min-width: 1024px) {
        font-size: 35px;
        padding: 8px;
    }
`;

function useEscapeByClose(visible, dismissable, onClose) {
    useEffect(() => {
        if (!visible || !dismissable) {
            return;
        }

        function onKeyDown(e) {
            if (e.key === 'Escape') {
                onClose();
            }
        }

        document.body.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.removeEventListener('keydown', onKeyDown);
        };
    }, [visible, dismissable, onClose]);
}

export function InformationDialog({
    visible,
    dismissable,
    top,
    width,
    onClose,
    onClickOverlay,
    children,
}) {
    function stopPropagation(e) {
        e.stopPropagation();
    }

    useEscapeByClose(visible, dismissable, onClose);

    return (
        <RootPortal>
            <Overlay
                className="dialog-overlay"
                onClick={onClickOverlay}
                visible={visible}
                top={top}
            >
                <StyledInformationDialog
                    className="dialog"
                    onClick={stopPropagation}
                    width={width}
                >
                    {dismissable &&
                        <InformationDialogCloseButton
                            className="dialog-overlay-close"
                            href="#"
                            onClick={onClose}
                        >
                            &times;
                        </InformationDialogCloseButton>
                    }
                    <StyledInformationDialogContentWrapper>
                        {children}
                    </StyledInformationDialogContentWrapper>
                </StyledInformationDialog>
            </Overlay>
        </RootPortal>
    );
}
